// src/lib/http.ts

export type ApiResult<T> = { ok: true; data: T } | { ok: false; error: string };

export async function getJson<T>(url: string, timeoutMs = 12000): Promise<ApiResult<T>> {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url, {
      signal: controller.signal,
      cache: "no-store",
      headers: {
        accept: "application/json",
        "cache-control": "no-cache, no-store, max-age=0",
        pragma: "no-cache"
      }
    });

    if (!res.ok) {
      const msg = await res.text().catch(() => res.statusText);
      return { ok: false, error: `HTTP ${res.status}: ${msg.slice(0, 180)}` };
    }

    return { ok: true, data: (await res.json()) as T };
  } catch (e: any) {
    return { ok: false, error: e?.name === "AbortError" ? "Request timed out" : "Network error" };
  } finally {
    clearTimeout(t);
  }
}